import Vue from 'vue'
import Router from 'vue-router'
import logIn from '@/components/logIn'
import home from '@/components/home'
import my from '@/components/my'
import extension from '@/components/extension'
import huawu from '@/components/huawu'
import detail from '@/components/detail'
import search from '@/components/search'
import upFile from '@/components/upFile'
import sybList from '@/components/sybList'
import hyList from '@/components/hyList'
import applyHy from '@/components/applyHy'
import returnDetail from '@/components/returnDetail'
import returnView from '@/components/returnView'


Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/upFile',
      name: 'upFile',
      component: upFile
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      children:[
        {                                     //三级路由
          path:'/home/extension',
          name:'extension',
          component:extension,
        },
        {                                     //三级路由
          path:'/home/huawu',
          name:'huawu',
          component:huawu,
        },
        {
          path:'/home/my',
          name:'my',
          component:my
        },
      ]
    },
    {
      path: '/detail',
      name: 'detail',
      component: detail
    },
    {
      path: '/search',
      name: 'search',
      component: search
    },
    {
      path: '/sybList',
      name: 'sybList',
      component: sybList
    },
    {
      path: '/hyList',
      name: 'hyList',
      component: hyList
    },
    {
      path: '/applyHy',
      name: 'applyHy',
      component: applyHy
    },
    {
      path: '/returnDetail',
      name: 'returnDetail',
      component: returnDetail
    },
    {
      path: '/returnView',
      name: 'returnView',
      component: returnView
    },

    {
      path: '/logIn',
      name: 'logIn',
      component: logIn
    },
    {
      path: '/',
      name: 'logIn',
      component: logIn
    },

  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js